import React, { useState, useEffect } from "react";

import {
  Table,
  Button,
  Modal,
  Row,
  Col,
  Badge,
  Form,
  OverlayTrigger,
  Popover,
  Tooltip
} from "react-bootstrap";
import { FiClock, FiAlertCircle, FiCheckCircle, FiInfo } from "react-icons/fi";


import {
  Calendar,
  Search,
  Box,
  Truck,
  CheckCircle,
  Info,
  ArrowRight,
  Clock,
} from "lucide-react";

const SalesChart = () => {
  const [urgentOrders, setUrgentOrders] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

const [statusFilter, setStatusFilter] = useState("ORDINE CONFERMATO");
  const [tempDates, setTempDates] = useState({ start: "", end: "" });

  const [appliedDates, setAppliedDates] = useState({ start: "", end: "" });

  const [showModal, setShowModal] = useState(false);

  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())

      .then((json) => {
        const ordiniRaw = json?.STATO_ORDINI?.flat() || [];

        const sorted = ordiniRaw.sort((a, b) =>
          String(a["Num Doc"]).localeCompare(String(b["Num Doc"])),
        );

        setUrgentOrders(sorted);
      })

      .catch((err) => console.error("Errore:", err));
  }, []);

  const getStatusStyle = (stato) => {
    const map = {
      "ORDINE CONFERMATO": {
        bg: "#e9ecef",
        color: "#495057",
        icon: <Calendar size={12} />,
      },

      "IN ARRIVO": {
        bg: "#fff5f5",
        color: "#e03131",
        icon: <Truck size={12} />,
      },

      "IN MAGAZZINO": {
        bg: "#e6fcf5",
        color: "#099268",
        icon: <Box size={12} />,
      },

      COMPLETATO: {
        bg: "#ebfbee",
        color: "#2f9e44",
        icon: <CheckCircle size={12} />,
      },

      GESTITO: {
        bg: "#f3f0ff",
        color: "#6741d9",
        icon: <CheckCircle size={12} />,
      },
    };

    return (
      map[stato] || {
        bg: "#fff9db",
        color: "#f08c00",
        icon: <Info size={12} />,
      }
    );
  };

  // Funzione per calcolare il badge del ritardo

const getDelayBadge = (dateString) => {
    const orderDate = new Date(dateString);
    const today = new Date();
    const diffTime = Math.abs(today - orderDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Stile comune per i badge
    const badgeStyle = { fontSize: '0.65rem', padding: '6px 10px' };

    if (diffDays <= 3) {
      return <Badge bg="success" style={badgeStyle}>IN ORARIO</Badge>;
    } else if (diffDays <= 7) {
      return <Badge bg="warning" text="dark" style={badgeStyle}>ATTENZIONE</Badge>;
    } else {
      return <Badge bg="danger" style={badgeStyle}>IN RITARDO</Badge>;
    }
  };

  const filteredOrders = urgentOrders.filter((order) => {
    const orderDate = new Date(order["Data Ordine"])
      .toISOString()
      .split("T")[0];

    const s = searchTerm.toLowerCase();

    const matchesSearch =
      order["Num Doc"]?.toString().toLowerCase().includes(s) ||
      order["Ragione sociale"]?.toString().toLowerCase().includes(s) ||
      order["Rag Soc Cli"]?.toString().toLowerCase().includes(s);

    const matchesStatus =
      statusFilter === "TUTTI" || order.STATO === statusFilter;

    const matchesStart =
      appliedDates.start === "" || orderDate >= appliedDates.start;

    const matchesEnd = appliedDates.end === "" || orderDate <= appliedDates.end;

    return matchesSearch && matchesStatus && matchesStart && matchesEnd;
  });

  const renderTimelineStep = (label, date) => {
    const isDone = date && date !== "null";

    return (
      <Col className="text-center px-2">
        <div
          style={{
            fontSize: "0.6rem",
            fontWeight: "800",
            color: isDone ? "#0d6efd" : "#adb5bd",
            textTransform: "uppercase",
            marginBottom: "8px",
          }}
        >
          {label}
        </div>

        <div
          style={{
            height: "4px",

            backgroundColor: isDone ? "#0d6efd" : "#e9ecef",

            borderRadius: "2px",

            marginBottom: "8px",

            position: "relative",
          }}
        >
          {isDone && (
            <div
              style={{
                position: "absolute",
                top: "-4px",
                left: "50%",
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                backgroundColor: "#0d6efd",
                transform: "translateX(-50%)",
              }}
            ></div>
          )}
        </div>

        <div
          style={{
            fontSize: "0.7rem",
            color: isDone ? "#212529" : "#dee2e6",
            fontWeight: isDone ? "600" : "400",
          }}
        >
          {isDone ? new Date(date).toLocaleDateString("it-IT") : "--/--"}
        </div>
      </Col>
    );
  };


const renderTooltip = (props) => (
    <Tooltip id="info-performance-tooltip" {...props}>
      <div style={{ textAlign: 'left', fontSize: '0.75rem', padding: '8px', lineHeight: '1.4' }}>
        <strong className="d-block mb-1" style={{ color: '#0d6efd' }}>GUIDA RAPIDA:</strong>
        <ul style={{ margin: 0, paddingLeft: '15px' }}>
          <li><strong>Ricerca:</strong> Filtra per Numero Doc, Fornitore o Cliente.</li>
          <li><strong>Stato:</strong> Di default vedi "Ordini Confermati". Cambia il filtro per vedere gli altri stati.</li>
          <li><strong>Date:</strong> Usa il calendario per filtrare gli ordini per data di emissione.</li>
          <li><strong>Timeline:</strong> Clicca su una riga per aprire il dettaglio e vedere l'avanzamento cronologico (BEM, ODP, Bolla).</li>
          <li><strong>Priorità:</strong> I badge indicano il ritardo rispetto alla data dell'ordine (Success &lt; 3gg, Warning &lt; 7gg, Danger &gt; 7gg).</li>
        </ul>
      </div>
    </Tooltip>
  );
  return (
    <div
      className="bg-white shadow-sm"
      style={{
        borderRadius: "16px",
        maxHeight: "400px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        border: "1px solid #eee",
      }}
    >
       <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
                <div className="p-3 bg-light d-flex align-items-center">
                      <span style={{ fontWeight: "700", fontSize: "0.75rem", color: "#495057", letterSpacing: "1px", marginRight: "8px" }}>
                        STATO ORDINI
                      </span>
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 100, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                          <FiInfo size={14} color="#6c757d" />
                        </span>
                      </OverlayTrigger>
                    </div>

        <div className="d-flex gap-3 align-items-center">
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            rootClose
            overlay={
              <Popover
                className="shadow-lg border-0 p-3"
                style={{ borderRadius: "12px" }}
              >
                <Form.Group className="mb-2">
                  <Form.Label className="small fw-bold">
                    Intervallo Date
                  </Form.Label>

                  <Form.Control
                    type="date"
                    size="sm"
                    className="mb-2"
                    value={tempDates.start}
                    onChange={(e) =>
                      setTempDates({ ...tempDates, start: e.target.value })
                    }
                  />

                  <Form.Control
                    type="date"
                    size="sm"
                    value={tempDates.end}
                    onChange={(e) =>
                      setTempDates({ ...tempDates, end: e.target.value })
                    }
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  size="sm"
                  className="w-100"
                  onClick={() => {
                    setAppliedDates(tempDates);
                    document.body.click();
                  }}
                >
                  Applica
                </Button>
              </Popover>
            }
          >
            <Button
              variant="light"
              className="border-0 shadow-sm"
              style={{
                borderRadius: "10px",
                fontSize: "0.8rem",
                padding: "8px 15px",
              }}
            >
              <Calendar size={16} className="me-2 text-primary" />
            </Button>
          </OverlayTrigger>

          <Form.Select
            size="sm"
            className="border-0 shadow-sm"
            style={{ borderRadius: "10px", width: "180px", height: "38px" }}
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="TUTTI">Tutti gli stati</option>

            {[
              "ORDINE CONFERMATO",
              "IN ARRIVO",
              "IN MAGAZZINO",
              "PRESO IN CARICO",
              "BEM INVIATA",
              "COMPLETATO",
            ].map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </Form.Select>

          <div className="position-relative">
            <Search
              size={16}
              className="position-absolute"
              style={{
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#adb5bd",
              }}
            />

            <Form.Control
              size="sm"
              className="border-0 shadow-sm"
              placeholder="Cerca tutto..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                borderRadius: "10px",
                width: "260px",
                paddingLeft: "38px",
                height: "38px",
              }}
            />
          </div>
        </div>
      </div>

      <style>{`

        .scroll-area { overflow-y: auto; flex-grow: 1; padding: 20px; background-color: #f8f9fa; }

        .custom-table { border-collapse: separate; border-spacing: 0 8px; }

        .doc-header-row td { background: #f1f3f5 !important; border: none !important; border-radius: 8px; padding: 12px 20px !important; }

        .item-row { cursor: pointer; transition: all 0.2s; }

        .item-row td { background: white !important; border: none !important; padding: 15px 20px !important; vertical-align: middle; }

        .item-row:hover td { background: #f0f7ff !important; transform: translateY(-1px); }

        .item-row td:first-child { border-top-left-radius: 12px; border-bottom-left-radius: 12px; }

        .item-row td:last-child { border-top-right-radius: 12px; border-bottom-right-radius: 12px; }

        .status-badge { display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; borderRadius: 8px; font-weight: 700; font-size: 0.65rem; text-transform: uppercase; border: none; }

      `}</style>

      <div className="scroll-area">
        <Table className="custom-table">
          <thead>
            <tr
              className="text-muted"
              style={{
                fontSize: "0.7rem",
                textTransform: "uppercase",
                letterSpacing: "1px",
              }}
            >
              <th>Articolo</th>

              <th>Descrizione</th>

              <th>Data</th>

              <th>Stato Processo</th>

              <th className="text-end">Priorità</th>
            </tr>
          </thead>

          <tbody>
            {filteredOrders.map((ordine, index) => {
              const showHeader =
                index === 0 ||
                ordine["Num Doc"] !== filteredOrders[index - 1]["Num Doc"];

              const style = getStatusStyle(ordine.STATO);

              return (
                <React.Fragment key={index}>
                  {showHeader && (
                    <tr className="doc-header-row">
                      <td colSpan={5}>
                        <div className="d-flex align-items-center gap-4">
                          <Badge bg="primary" style={{ fontSize: "0.7rem" }}>
                            DOC #{ordine["Num Doc"]}
                          </Badge>

                          <span
                            style={{ fontSize: "0.8rem", fontWeight: "600" }}
                          >
                            <small className="text-muted fw-normal">
                              Fornitore:
                            </small>{" "}
                            {ordine["Ragione sociale"]}
                          </span>

                          <span
                            style={{ fontSize: "0.8rem", fontWeight: "600" }}
                          >
                            <small className="text-muted fw-normal">
                              Cliente:
                            </small>{" "}
                            {ordine["Rag Soc Cli"]}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}

                  <tr
                    className="item-row shadow-sm"
                    onClick={() => {
                      setSelectedOrder(ordine);
                      setShowModal(true);
                    }}
                  >
                    <td>
                      <div
                        className="fw-bold text-primary"
                        style={{ fontSize: "0.85rem" }}
                      >
                        {ordine["Articolo"]}
                      </div>
                    </td>

                    <td
                      style={{
                        fontSize: "0.8rem",
                        color: "#444",
                        maxWidth: "300px",
                      }}
                    >
                      {ordine["Descrizione"]}
                    </td>

                    <td style={{ fontSize: "0.8rem" }}>
                      {new Date(ordine["Data Ordine"]).toLocaleDateString(
                        "it-IT",
                      )}
                    </td>

                    <td>
                      <div
                        className="status-badge"
                        style={{
                          backgroundColor: style.bg,
                          color: style.color,
                          borderRadius: "6px",
                        }}
                      >
                        {style.icon} {ordine.STATO}
                      </div>
                    </td>

                    <td className="text-end">
                      {getDelayBadge(ordine["Data Ordine"])}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        className="p-5 rounded"
      >
        <Modal.Body className="p-0">
          <div className="p-4 border-bottom bg-light d-flex justify-content-between align-items-center">
            <div>
              <div
                className="text-primary fw-bold"
                style={{ fontSize: "0.7rem", textTransform: "uppercase" }}
              >
                Dettaglio Avanzamento
              </div>

              <h4 className="mb-0 fw-bold">{selectedOrder?.Articolo}</h4>
            </div>

            <Button
              variant="link"
              onClick={() => setShowModal(false)}
              className="text-dark"
            >
              <Box />
            </Button>
          </div>

          <div className="p-5">
            <Row className="mb-5">
              {selectedOrder && (
                <>
                  {renderTimelineStep("Ordine", selectedOrder["Data Ordine"])}

                  {renderTimelineStep(
                    "In Magazzino",
                    selectedOrder["Data Entrata Magazzino"],
                  )}

                  {renderTimelineStep(
                    "In Carico",
                    selectedOrder["Data Presa in carico *"],
                  )}

                  {renderTimelineStep(
                    "BEM",
                    selectedOrder["Data Completamento BEM"],
                  )}

                  {renderTimelineStep(
                    "ODP",
                    selectedOrder["Data Completamento ODP\/ODPV"],
                  )}

                  {renderTimelineStep("Bolla", selectedOrder["data_bolla"])}
                </>
              )}
            </Row>

            <Row className="g-4">
              <Col md={6}>
                <div className="p-4 rounded-4 bg-light h-100">
                  <h6 className="fw-bold mb-3">Informazioni Spedizione</h6>

                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted small">Cliente:</span>

                    <span className="fw-bold small">
                      {selectedOrder?.["Rag Soc Cli"]}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted small">Fornitore:</span>

                    <span className="fw-bold small">
                      {selectedOrder?.["Ragione sociale"]}
                    </span>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div className="p-4 rounded-4 border h-100 d-flex align-items-center justify-content-around text-center">
                  <div>
                    <div className="text-muted small">Ordinata</div>

                    <div className="h4 fw-bold mb-0">
                      {parseInt(selectedOrder?.Quantita || 0)}
                    </div>
                  </div>

                  <ArrowRight className="text-muted" />

                  <div>
                    <div className="text-success small">Evasi</div>

                    <div className="h4 fw-bold text-success mb-0">
                      {parseInt(selectedOrder?.["Qta EVA"] || 0)}
                    </div>
                  </div>

                  <div className="vr mx-2"></div>

                  <div>
                    <div className="text-danger small">Residuo</div>

                    <div className="h4 fw-bold text-danger mb-0">
                      {parseInt(selectedOrder?.["Qta DEV"] || 0)}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SalesChart;
